import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'marv-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    imports: []
})
export class MarvCardComponent  implements OnInit {

    constructor() { }

    ngOnInit() {}

}
